
import styled from 'styled-components'
import Dots from '../components/Icon/Dots'
import DropdownIcon from '../components/Icon/DropdownIcon'
import SearchIcon from '../components/Icon/SearchIcon'
import Hollow from '../components/Icon/Hollow'
import Checked from '../components/Icon/Checked'
import AddIcon from '../components/Icon/AddIcon'
import { useData } from '../context/DataProvider'
import { useEffect, useRef, useState } from 'react'
import NewlyLaunchedProducts from './NewlyLaunchedProducts'
import DownloadIcon from '../components/Icon/DownloadIcon'
import Loader from '../components/Loader'
import { Refresh } from '../components/Icon/Refresh'
import { Cross } from '../components/Icon/Cross'
import ClearIcon from '../components/Icon/Clear'
import { Warn } from '../components/Icon/Warn'
import CsvModal from '../components/CsvModal'
import RedirectModal from '../components/RedirectModal'
import SaveReport from '../components/Icon/SaveReport'
import SaveReportModal from '../components/SaveReportModal'
import { useLocation } from 'react-router-dom'
import SavedFull from '../components/Icon/SavedFull'
import { cosmeticIQApi } from '../service/api'

const ReportBuilderOption = () => {
    const { builderSearch ,builderExecute,reportResponse, setReportResponse, sessionExpired} = useData();
    const [additionalResults,setAdditionalResults] = useState(false);
    const [csvUrl,setCsvUrl] = useState('');
    const [isAlreadySaved,setIsAlreadySaved] = useState(false);
    const [isCsvModalOpen,setIsCsvModalOpen] = useState(false);
    const {data,setData} = useData();
    const [saved,setSaved] = useState(false);
    const [ searchFlag,setSearchFlag] = useState(false);
    const [ noRsultMsg,setNoResultMsg] = useState('');
    const [operator, setOperator] = useState({isOpen:false,option:"and"});
    const [loading, setLoading] = useState(false);
    const builderRef = useRef(null);
    const operatorRef = useRef(null);
    const [isOpenSaveReportModal, setIsOpenSaveReportModal] = useState(false);
    const searchTimeoutRef = useRef(null);
    const [cond,setCond]= useState([])
    const location = useLocation();
    const report = location.state?.report;
    const savedReport= location.state?.savedReport;
       const findMatch = async()=>{
            const alreadySavedd = isReportAlreadySaved(cond, data?.savedReports);
            setIsAlreadySaved(alreadySavedd);
            
            
        if (alreadySavedd && report?.docId)
        {
            // if(report?.product_count !== reportResponse?.length)
            // {
                await cosmeticIQApi.updatedata({id:report?.docId,product_count:reportResponse?.length,type:'reports'});
                       const resp = await cosmeticIQApi.fetchSavedReports();
                       setData(prev => ({ ...prev, savedReports: resp }));
            // }

        }
    }
    useEffect(()=>{

            const alreadySavedd = isReportAlreadySaved(cond, data?.savedReports);
            setIsAlreadySaved(alreadySavedd);

    },[isOpenSaveReportModal])
    useEffect(()=>{
     
        findMatch();
    },[reportResponse]);
    
const normalizeCondition = (c) => {
    const sortedValues = [...(c.values || [])]
        .map(v => v.id)
        .sort()
        .join(',');

    return `${c.logic}|${c.combination}|${c.table}|${sortedValues}`;
};


const normalizeConditions = (conditions = []) => {
    return conditions
        .map(normalizeCondition)
        .sort()
        .join(';');
};

const isReportAlreadySaved = (cond, savedReports = []) => {
    if (!cond?.conditions) return false;

    const target = normalizeConditions(cond.conditions);

    return savedReports.some(saved =>
        normalizeConditions(saved.conditions) === target
    );
};

    
    const [conditions, setConditions] = useState([
        {
            type: "condition",
            logic: "WITH",
            combination: "ANY",
            table: "BRAND",
            values: [],
            isOpenCombination: false,
            isOpenCondition: false,
            isOpenTable: false,
            searchText: '',
            showSuggestions: false,
            suggestions: []
        }
    ]);
    
    useEffect(() => {
    setSaved(savedReport);
    if (savedReport && report?.conditions) {
        const normalized = report.conditions.map(c => ({
            type: c.type ?? "condition",
            logic: (c.logic ?? "with").toUpperCase(),
            combination: (c.combination ?? "any").toUpperCase(),
            table: (c.table ?? "brand").toUpperCase(),
            values: c.values ?? [],
            isOpenCombination: false,
            isOpenCondition: false,
            isOpenTable: false,
            searchText: '',
            showSuggestions: false,
            suggestions: []
        }));
        setReportResponse([]);
        setConditions(normalized);
    }
}, []);
    const addNewBlock = () => {
        setConditions([...conditions, {
            type: "condition",
            logic: "WITH",
            combination: "ANY",
            table: "BRAND",
            values: [],
            isOpenCombination: false,
            isOpenCondition: false,
            isOpenTable: false,
            searchText: '',
            showSuggestions: false,
            suggestions: []
        }]);
    };
const refresh = () => {
    setReportResponse([])
    setCond([])
    setSaved(false)
    // setOperator({isOpen:false,option:"and"});
    

}
    const toggleDropdown = (index, dropdownType) => {
  setConditions(prev =>
    prev.map((c, i) =>
      i === index
        ? {
            ...c,
            isOpenCondition: dropdownType === 'Condition' ? !c.isOpenCondition : false,
            isOpenCombination: dropdownType === 'Combination' ? !c.isOpenCombination : false,
            isOpenTable: dropdownType === 'Table' ? !c.isOpenTable : false,
          }
        : {
            ...c,
            isOpenCondition: false,
            isOpenCombination: false,
            isOpenTable: false,
          }
    )
  );
};

    useEffect(()=>{
        
    },[reportResponse])
useEffect(() => {
  const handleClick = (e) => {
    // Check if click is inside any dropdown wrapper
    const clickedInsideDropdown = e.target.closest('[data-dropdown]');
    
    if (!clickedInsideDropdown) {
      // Close all dropdowns if click is outside all of them
      setOperator(prev => ({ ...prev, isOpen: false }));
      setConditions(prev =>
        prev.map(c => ({
          ...c,
          isOpenCondition: false,
          isOpenCombination: false,
          isOpenTable: false,
        
        }))
      );
    }
  };
  document.addEventListener('mousedown', handleClick);
  return () => document.removeEventListener('mousedown', handleClick);
}, []);




      useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);
    const updateCondition = (index, key, value) => {
        setConditions(prevConditions => {
            const newConditions = [...prevConditions];
            const block = { ...newConditions[index] };
    
            // If the user changes the table type (Brand, Category, Ingredient), clear values
            if (key === 'table' && block.table !== value) {
                block.values = [];
                block.searchText = '';
                block.suggestions = [];
            }
    
            block[key] = value;
            block.isOpenCondition = false;
            block.isOpenCombination = false;
            block.isOpenTable = false;
    
            newConditions[index] = block;
            return newConditions;
        });
    };
  

    const handleSearchChange = (index, value) => {
        setConditions(prevConditions => {
            const newConditions = [...prevConditions];
            newConditions[index] = {
                ...newConditions[index],
                searchText: value,
                showSuggestions: true
            };
            return newConditions;
        });
    
        // Clear previous timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
    
        if (value) {
            searchTimeoutRef.current = setTimeout(async () => {
                try {
                    const results = await builderSearch(value, conditions[index].table.toLowerCase());
                    
                    if(results.length === 0 )
                    setSearchFlag(true);
                    else
                    setSearchFlag(false);
                    setConditions(prevConditions => {
                        const newConditions = [...prevConditions];
                        newConditions[index].suggestions = results.map(item => ({
                            id: item.id,
                            text: item.name,
                            checked: newConditions[index].values.some(val => val.id === item.id)
                        }));
                        return newConditions;
                    });
                    
                } catch (error) {
                    console.error(error);
                }
            }, 1000);
        }
        else
        setSearchFlag(false);
    };
    
    function convertToCSV(data) {
        const rows = data.map((item) => 
            `"${item.brand}","${item.name}",${item.discontinued},${item.priceRange},"${item.attributes.map(attribute => attribute.name).join(', ')}","${item.brand_retailers.map(brand_retailer => brand_retailer.name).join(', ')}","${item.categories.map(cat => cat.name).join(', ')}","${item.ingredients}"`
          );
          
          
        return "Brand,Name,Discontinued,Price Range,Attributes,Brand Retailer History,Category,Ingredients\n" + rows.join("\n");
      }
    const runReport = () => {
        
      setSaved(false);
        setNoResultMsg('');
        setLoading(true);
    const report = generateReport();

    
    setCond(report);

    builderExecute(report).then((response) => {
        if(response.error)
            {
                setNoResultMsg(response.error);
                setLoading(false)
                return;
            }
    if(response.products.length === 0){
        setNoResultMsg(response.message);
        setLoading(false)
    }
    else
    { const csvString = convertToCSV(response.products);
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    setCsvUrl(url);
    setLoading(false)
    const newProducts = response.products;
    
    setAdditionalResults(response.additionalResults)
    setData({
  ...data,
  resultCount: response.resultCount,
  totalResultCount: response.totalResultCount,
});
   
    setReportResponse(newProducts);
    }
    
}).catch((error) => {
    
    setLoading(false);});


    }
    const downloadCsv = () => {
        setIsCsvModalOpen(true);
        // const a = document.createElement("a");
        // a.href = csvUrl;
        // a.download = "report.csv";
        // a.click();
        // URL.revokeObjectURL(csvUrl);
        
    
    }
    const handleSuggestionClick = (suggestion, blockIndex) => {
        setConditions(prevConditions => {
            const newConditions = [...prevConditions];
            const block = { ...newConditions[blockIndex] }; 
    
            const valueIndex = block.values.findIndex(v => v.id === suggestion.id);
    
            if (valueIndex === -1) {
                block.values = [...block.values, { id: suggestion.id, name: suggestion.text }];
                // block.searchText = ''; // Clear search text after adding a suggestion
                // block.showSuggestions = false; // Hide suggestions
            } else {
                block.values = block.values.filter(v => v.id !== suggestion.id);
            }
    
            block.suggestions = block.suggestions.map(s => 
                s.id === suggestion.id 
                    ? { ...s, checked: !s.checked } 
                    : s
            );
    
            newConditions[blockIndex] = block;
    
            return newConditions;
        });
    };
    const getFilteredSuggestions = (blockIndex) => {
        const block = conditions[blockIndex];
        return block.suggestions
        ;
    };

    const generateReport = () => {
        
        return {
            type: "logic",
            operator: operator.option,
            conditions: conditions.map(condition => ({
                type: "condition",
                logic: condition.logic.toLowerCase(),
                combination: condition.combination.toLowerCase(),
                table: condition.table.toLowerCase(),
                values: condition.values
            }))
        };
    };

    const removeBlock = (index) => {
        setConditions(prevConditions => prevConditions.filter((_, i) => i !== index));
    };


    return (
        <Container>
            <SaveReportModal isOpen={isOpenSaveReportModal} onClose={()=>setIsOpenSaveReportModal(false)} data={cond} productCount = {reportResponse.length}/>
            <RedirectModal isOpen={sessionExpired}/>
           <CsvModal
  isOpen={isCsvModalOpen}
  onClose={() => setIsCsvModalOpen(false)}
  fields={["Brand","Name","Discontinued","Price Range","Attributes","Brand Retailer History","Category","Ingredients",'Date Launched',"Description"]}
  data={reportResponse} // array of products
/>
            <Main ref={builderRef}>
                {
                    reportResponse.length > 0 && !saved ?
                    
                    <div style={{width:"100%",display:'flex',gap:24,flexDirection:'column'}}>
                    <DownloadDiv onlyRefresh={!data.userData.access_download}>
                        {data.userData.access_download &&
                        <div style={{display:'flex',gap:10}}>
                            {isAlreadySaved ?
                        <SaveReportB cursor = {'not-allowed'} disabled={isAlreadySaved}>
                         
                            
                            <SavedFull/>
                            <SaveReportTxt color='#202327'>Saved report</SaveReportTxt>
                        </SaveReportB>    
                            :
                            <SaveReportB  cursor = {'pointer'} onClick={()=>setIsOpenSaveReportModal(true)}>
                                <SaveReport/>
                            <SaveReportTxt>Save report</SaveReportTxt>
                            </SaveReportB>
                            }

                        
                        
                    <DownloadCsvButton onClick={downloadCsv}>
                      <DownloadIcon size = '20'/>
                       <DownloadCsvButtonTxt>Download report as .csv</DownloadCsvButtonTxt>
                    </DownloadCsvButton>
                    </div>}
                    <AnP1 onClick={refresh}>
                    <Refresh/>
                    <AnP1Text>
                    Return to report builder
                    </AnP1Text>
                    </AnP1>
                    </DownloadDiv>
                    <NewlyLaunchedProducts additionalResults={additionalResults} newProducts = {reportResponse}/> 
                    
                    </div>
                    
                    : 
                    
                <>

<DropdownWrapper ref={operatorRef} style={{ height: 30 }} data-dropdown>
      <DropdownInput  style={{alignItems:'center',justifyContent:'space-between'}}
        onClick={() =>
          setOperator((prev) => ({ ...prev, isOpen: !prev.isOpen }))
        }
      >
        <M121Txt>{operator.option.toUpperCase()}</M121Txt>
        <DropdownIcon />
      </DropdownInput>
      <OptionsList isOpen={operator.isOpen}>
        {["AND", "OR"].map((option, idx) => (
          <DropdownOption
            isFirst={idx === 0}
            isLast={idx === 1}
            key={option}
            onClick={() =>
              setOperator({ isOpen: false, option: option.toLocaleLowerCase() })
            }
          >
            {option.toUpperCase()}
          </DropdownOption>
        ))}
      </OptionsList>
    </DropdownWrapper>
  <div style={{gap:10,display:'flex',flexDirection:'column'}}>
                {conditions.map((condition, index) => (
                    <M1 key={index}>
                        <M11>
                            <M11Text>
                                Condition block #{index + 1}
                            </M11Text>
                            {index > 0 ? <ClearBtn onClick={() => removeBlock(index)}>
          <ClearIcon/>
          </ClearBtn>
          :
          <Dots/>
          }
                            
                        </M11>
                        <M11Text>
                            condition
                        </M11Text>
                        <M12 >
                       
                            <DropdownWrapper data-dropdown>
                                <DropdownInput onClick={() => toggleDropdown(index, 'Condition')}>
                                    <M121Txt>
                                        {condition.logic}
                                    </M121Txt>
                                    <DropdownIcon />
                                </DropdownInput>
                                <OptionsList isOpen={condition.isOpenCondition}>
                                    {["WITH","WITHOUT"].map((option,idx) => (
                                        <DropdownOption
                                        isFirst={idx === 0}
                                        isLast={idx ===  1}
                                            key={option}
                                            onClick={() => updateCondition(index, 'logic', option)}
                                        >
                                            {option}
                                        </DropdownOption>
                                    ))}
                                </OptionsList>
                            </DropdownWrapper>

                            <DropdownWrapper data-dropdown>
                                <DropdownInput onClick={() => toggleDropdown(index, 'Combination')}>
                                    <M121Txt>
                                        {condition.combination}
                                    </M121Txt>
                                    <DropdownIcon />
                                </DropdownInput>
                                <OptionsList isOpen={condition.isOpenCombination}>
                                    {["ANY","ALL"].map((option,idx) => (
                                        <DropdownOption
                                        isFirst={idx === 0}
                                        isLast={idx === 1}
                                            key={option}
                                            onClick={() => updateCondition(index, 'combination', option)}
                                        >
                                            {option}
                                        </DropdownOption>
                                    ))}
                                </OptionsList>
                            </DropdownWrapper>

                            <DropdownWrapper data-dropdown style={{background: "linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)"}}>

                                <DropdownInput onClick={() => toggleDropdown(index, 'Table')}>
                                    <M121Txt>
                                        {condition.table}
                                    </M121Txt>
                                    <DropdownIcon />
                                </DropdownInput>
                                <OptionsList isOpen={condition.isOpenTable}>
                                    {["BRAND", "CATEGORY", "INGREDIENT","GROUP"].map((option,idx) => (
                                        <DropdownOption
                                        isFirst={idx === 0}
                                        isLast={idx === 3}
                                            key={option}
                                            onClick={() => updateCondition(index, 'table', option)}
                                        >
                                            {option}
                                        </DropdownOption>
                                    ))}
                                </OptionsList>
                            </DropdownWrapper>
                        </M12>
                        <M14 style={{gap:searchFlag ? '32px': '10px'}}>
                           
                            <M141>
                                <SearchIcon />
                                <M141Txt
                                    placeholder="search ..."
                                    value={condition.searchText}
                                    onChange={(e) => handleSearchChange(index, e.target.value)}
                                    onFocus={() => {
                                        setConditions(prev => {
                                            const newState = [...prev];
                                            newState[index].showSuggestions = true;
                                            return newState;
                                        });
                                    }}
                                />
                                {condition.searchText && 
                                <CrossBtn onClick={() => {
                                    setSearchFlag(false);
                                    setConditions(prev => {
                                        const newState = [...prev];
                                        newState[index].searchText = '';
                                        newState[index].showSuggestions = false;
                                        return newState;
                                    }
                )}}>
                                <Cross/>
                                </CrossBtn>
                                }
                            </M141>
                            
                            
                            
                          {
                            searchFlag ?  
                            <SearchFlagView>
                            <Warn/>
                            <AnP1Text style={{color:'#202327'}}>No results.</AnP1Text>
                            </SearchFlagView>
                            :
                            condition.showSuggestions && condition.searchText.length > 0 && (
                                <M1412>

                                    {getFilteredSuggestions(index).length > 0 ? getFilteredSuggestions(index).map((suggestion) => (
                                        
                                            <M14121 key={suggestion.id} onClick={() => handleSuggestionClick(suggestion, index)}>
                                                <div style={{width:18,height:18}}>{suggestion.checked ? <Checked /> : <Hollow />}</div>
                                                <M14121Txt>
                                                    {suggestion.text}
                                                </M14121Txt>
                                            </M14121>
                                        
                                    ))
                                    :
                                    <p style={{textAlign:'center'}}>...</p>

                                    }
                                </M1412>
                                
                            )}

                            {condition.values.map((conditionn, i) => (
                              
                                    <ToggleButton key={i}  onClick={(e) => handleSuggestionClick({...conditionn,checked:true},index)}>
                                    <Checked />
                                    <M141Txt2>
                                        {conditionn.name} 
                                    </M141Txt2>
                                    </ToggleButton>
                            
                            ))}
                            
                            
                        </M14>
                    </M1>
                ))}
                </div>

                <AddButton onClick={addNewBlock}>
                    <AddIcon/>
                    <M11Text>
                        Add new block
                    </M11Text>
                </AddButton>
                <AddButton onClick={runReport} disabled={loading || conditions[0].values.length === 0}>
                    {/* <AddIcon/> */}
                  {loading ? <Loader/> :
                    <M11Text>
                        Run report
                    </M11Text>}
                </AddButton>
                <M121Txt style={{color:'red'}}>{noRsultMsg}</M121Txt>
                </>}
            </Main>

        </Container>
    );
}
export default ReportBuilderOption

const Container = styled.div`
width: 1,228px;

padding: 30px;
gap: 30px;
border: 0px 1px 0px 0px;

`

const DownloadDiv = styled.div`
width: 100%;
height: 40px;
gap: 0px;
display:flex;

 justify-content: ${props => props.onlyRefresh ? 'flex-end' : 'space-between'};
align-items:center;

opacity: 0px;


`
const SaveReportB = styled.button`
height: 40px;
border:none;
angle: 0 deg;
opacity: 1;
border-radius: 120px;
display:flex;
align-items:center;
justify-content:center;
flex-direction:row;
gap: 8px;
padding-right: 12px;
padding-left: 12px;
cursor: ${(props)=>props.cursor};
background: #F9F9F9;

`
const SaveReportTxt = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: 0%;
margin:0;
color: ${(props)=>props.color ? props?.color : '#20232799'};

`
const DownloadCsvButton = styled.button`
// width: 222px;
height: 40px;
cursor:pointer;
border:none;
padding: 0px 20px 0px 16px;
flex-direction:row;display:flex;
align-items:center;
justifySelf: start;
gap: 8px;
border-radius: 1000px;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);

`
const RefreshButton = styled.button`
background: red;
border:none;
display:flex;
align-items:center;
`
const AnP1 = styled.button`
padding: 4px 12px 4px 4px;
gap: 8px;
cursor:pointer;
border-radius: 1000px ;
border:none;
opacity: 0px;
background:#FFFFFF;
display:flex;
justify-content:center;
flex-direction:row;
align-items:center
`
const SearchFlagView = styled.div`
// background:red;
display:flex;
align-items:center;
gap: 10px;

`
const AnP1Text = styled.p`

font-size: 14px;
font-weight: 600;
line-height: 16.8px;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;
`
const DownloadCsvButtonTxt= styled.p`
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #202327;

`
const Main = styled.div`

width: 1,228px;
padding: 24px;

gap: 24px;
border-radius: 24px;
background: #FFFFFF;
overflow:scroll;
box-shadow: 0px 0px 24px 0px #2F323705;

display:flex;
align-items:center;
flex-direction:column;


opacity: 0px;
`

const M1 = styled.div`
width: 450px;

padding: 30px;
display:flex;
flex-direction:column;
gap: 30px;
border-radius: 18px;

background:#F9F9F9;
@media (max-width: 768px) {
        width:90%;
    }
`

const ClearBtn = styled.button`
background: none;
border:none;
`
const M11 = styled.div`

display:flex;
justify-content: space-between;
`
const M11Text = styled.div`

font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
color:#202327;
`

const M12 = styled.div`
width: 261px;
height: 29px;
display:flex;
gap: 8px;
opacity: 0px;
`

const M121 = styled.div`


padding: 8px 12px 6px 14px;
display:flex;
align-items:center;
gap: 8px;
border-radius: 64px;
opacity: 0px;
background: #2023270F;

`

const DropdownWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;


  padding: 8px 12px 6px 12px;
border-radius: 64px;
display:flex;
align-items:center;
justify-content: space-between;
flex-direction:row;

background: #2023270F;
  

  
`;

const DropdownInput = styled.div`
 
 
  cursor: pointer;
  

gap: 8px;

display:flex;
align-items:center;



  

`;

const OptionsList = styled.ul`
  position: absolute;
  
  
  top: calc(100% + 4px);
  list-style: none;
  margin: 0;

  padding: 0px ;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 10px 24px rgba(47, 50, 55, 0.1);
  z-index: 10;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  
`;


const DropdownOption = styled.li`
  padding: 8px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #202327;
  cursor: pointer;

  &:hover {
    background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
    ${({ isFirst, isLast }) =>
        isFirst === isLast ?
    "border-radius: 12px;" :
        isFirst
          ? "border-radius: 12px 12px 0 0;"
          : isLast
          ? "border-radius: 0 0 12px 12px;"
          : "border-radius: 0px;"}
    
    
    
  }
`;
const M121Txt = styled.p`

font-size: 12px;
font-weight: 800;
line-height: 14.4px;
letter-spacing: -0.01em;


text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#202327;

`

const M13 = styled.div`


padding: 8px 12px 6px 14px;
display:flex;
align-items:center;
gap: 8px;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);


border-radius: 64px;

`

const M14 = styled.div`


display:flex;
flex-direction:column;
gap: 10px;
opacity: 0px;

`
const M141 = styled.div`

padding: 12px;
align-items:center;
display:flex;
gap: 8px;
border-radius: 12px;
opacity: 0px;
background:#FFFFFF;
`
const CrossBtn = styled.button`
border:none;
background:none;

`
const M141Txt = styled.input`

font-size: 14px;
font-weight: 600;
line-height: 16.8px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#202327;

width: 100%;
outline:none;
border:none;
`
const M141Txt2 = styled.p`
font-size: 14px;
font-weight: 600;
line-height: 16.8px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#202327;

width: 100%;
outline:none;
border:none;`

const ToggleButton = styled.button `
padding: 12px;
align-items:center;
display:flex;
gap: 8px;
border-radius: 12px;
opacity: 0px;
background:#FFFFFF;
border:none;
cursor:pointer;

`
const M1412 = styled.div`


padding: 12px;
flex-direction:column;
display:flex;
gap: 10px;
border-radius: 12px;

background:#FFFFFF;

`

const M14121 = styled.div`

// height: 18px;
cursor:pointer;
display:flex;
align-items:center;
gap: 10px;
opacity: 0px;
`

const M14121Txt = styled.p`

font-size: 14px;
font-weight: 500;
line-height: 16.8px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#202327;
 white-space: pre-wrap;
  word-wrap: break-word;
`



const AddButton = styled.button`

height: 40px;

padding: 0px 20px 0px 16px;
gap: 8px;
border-radius: 1000px;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
align-items:center;
display:flex;
border:none;
cursor:pointer;


`